import type { _WorkbookApi } from '@mathflat/domain/@entities/(Content)/Workbook/api'
import type { WorkbookDomain } from '@mathflat/domain/@entities/(Content)/Workbook/domain'
import type { DefaultResponse, Pagination } from '@mathflat/shared/@types/mathflatApi'

import type { WorkbookPageData } from '../types'
import maxios from '../utils/maxios'

export const workbookApi = (() => {
  return {
    async getWorkbooks<
      T extends WorkbookDomain.Type = WorkbookDomain.Type,
      U extends 'GRADE' | 'CLASS' | 'STUDENT' = never,
    >(params: _WorkbookApi.Request.GetWorkbook<T, U>) {
      const {
        data: { content },
      } = await maxios.get<DefaultResponse<Pagination<_WorkbookApi.Response.GetWorkbook<T>[]>>>(
        '/workbook',
        {
          params,
        },
      )

      return content
    },
    getCustomSignatureWorkbookPages: async (workbookId: number) => {
      const { data } = await maxios.get<DefaultResponse<WorkbookPageData[]>>(
        `/workbook/custom-signature/${workbookId}/page`,
      )
      return data
    },
    getAcademyGroupWorkbookPages: async (workbookId: number) => {
      const data = await maxios.get<WorkbookPageData[]>(
        `/workbook/academy-group/${workbookId}/page`,
      )
      return data
    },
  }
})()
